module.exports = __webpack_public_path__ + "img/5电气时代.f9a549da.png";